// COMPONENTS
import { Icon, TEInput } from '@timeedit/ui-components';
import { Typography } from '@timeedit/ui-components/antd';
// STYLES
import './EditTextItem.scss';

type EditTextItemProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'onChange'
> & {
  title: string;
  disable?: boolean;
  onDelete?: (title: string) => void;
  onChange?: (value: string) => void;
};

const EditTextItem = ({
  title,
  onDelete,
  disable = false,
  onChange,
  ...rest
}: EditTextItemProps) => {
  return (
    <div className="edit-text-item" {...rest}>
      <div className="edit-text">
        {disable || !onChange ? (
          <Typography.Text ellipsis>{title}</Typography.Text>
        ) : (
          <TEInput.EditableTextInput
            variant="underlined"
            size="small"
            value={title}
            onConfirm={onChange}
          />
        )}
      </div>
      {!disable && onDelete && (
        <Icon
          id="DeleteOutlined"
          alt="Delete"
          onClick={() => onDelete(title)}
        />
      )}
    </div>
  );
};

export default EditTextItem;
